import React, { useRef, useState, useEffect } from 'react';
import '../../VendorStyles/UpdateItem.css';
import '../../VendorStyles/Menu.css';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axiosVendorInstance from '../../axiosVendorInstance';
import Loader from '../../Components/Loader/Loader';
import LeftArrow from '../../assets/backIcon-white.png';
import VendorImageMenuPlaceholderSvg from '../../assets/svg/vendorImageMenuPlaceholder';
function UpdateItem({
    itemId,
    handleSave,
    handleBack,
    menuTypes,
    setUpdatedImage,
    isLoading,
}) {
    const fileInputRef = useRef(null);
    const [previewFile, setPreviewFile] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        percentage: '',
        menuType: '',
        Ingredients: '',
        vegetarian: '',
        // Item-level availability and party tray metadata for Update
        Daily: true,
        Party: false,
        Small_tray: '',
        Medium_tray: '',
        Large_tray: '',
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        description: '',
        price: '',
        menuType: '',
        Ingredients: '',
        vegetarian: '',
        Small_tray: '',
        Medium_tray: '',
        Large_tray: '',
        partyTray: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchItemDetails = async () => {
        setLoading(true);
        try {
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`,
                { skipAuth: true }
            );
            const item = response?.data?.menuItem;
            const toBool = (v) => v === true || v === 'true' || v === 1 || v === '1';
            setFormData({
                id: item?.ID,
                name: item?.Item_name,
                description: item?.Description || '',
                price: item?.Price,
                percentage: item?.percentage,
                menuType: item?.Menu_id || '',
                Ingredients: item?.Ingridents,
                vegetarian: item?.vegetarian,
                Daily: typeof item?.Daily !== 'undefined' ? toBool(item?.Daily) : true,
                Party: toBool(item?.Party),
                Small_tray: item?.Small_tray ? String(item?.Small_tray) : '',
                Medium_tray: item?.Medium_tray ? String(item?.Medium_tray) : '',
                Large_tray: item?.Large_tray ? String(item?.Large_tray) : '',
            });

            if (item?.Avatar_key) {
                setPreviewFile(item?.Avatar_key);
                const fileExtension = item?.Avatar_key.split('.').pop().toLowerCase();
                if (
                    ['jpg', 'jpeg', 'png', 'webp', 'tiff', 'gif', 'bmp', 'html'].includes(
                        fileExtension
                    )
                ) {
                    setFileType('image');
                } else if (['mp4'].includes(fileExtension)) {
                    setFileType('video');
                } else {
                    setFileType(null);
                }
            }

            setLoading(false);
        } catch (err) {
            setError('Error fetching item details');
            console.error('Error fetching item details:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (itemId) {
            fetchItemDetails();
        }
    }, [itemId]);

    useEffect(() => {
        console.log('formData updated:', formData);
    }, []);

    if (error) {
        return <div>{error}</div>;
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        // Reset error message and preview
        setPreviewFile(null);

        if (file) {
            // Check file type
            const fileExtension = file.name.split('.').pop().toLowerCase();

            // Update valid file types array to include new formats
            const validImageTypes = [
                'jpg',
                'jpeg',
                'png',
                'webp',
                'tiff',
                'gif',
                'bmp',
            ];
            const validVideoTypes = ['mp4'];
            const validHtmlTypes = ['html']; // Added for .html files

            // Check if the file is an image or HTML file
            if (
                (validImageTypes.includes(fileExtension) &&
          file.type.startsWith('image/')) ||
        (validVideoTypes.includes(fileExtension) &&
          file.type.startsWith('video/')) ||
        (validHtmlTypes.includes(fileExtension) && file.type === 'text/html')
            ) {
                // Check file size (limit to 10MB only for images)
                const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
                if (fileSizeInMB > 50) {
                    // setImageError('Image file size should not exceed 10MB.');
                    console.log('File size should not exceed 50MB.');
                    return;
                }

                // Set the file type and uploaded file state
                const fileType = file.type.split('/')[0]; // 'image' or 'video'
                setFileType(fileType);
                setUpdatedImage(file);

                // Set the preview URL
                const previewUrl = URL.createObjectURL(file);
                setPreviewFile(previewUrl);
            } else {
                // setImageError('Only .jpg, .png images, .html files, or .mp4 videos are allowed.');
                console.log('upload valid Images or videos.');
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (formData[name] !== value) {
            // Only update if the value changes
            validateField(name, value); // Validate on change
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleIngredientsChange = (value) => {
        if (formData.Ingredients !== value) {
            // Only update if the value changes
            validateField('Ingredients', value); // Validate on change for React Quill
            setFormData({ ...formData, Ingredients: value });
        }
    };

    const handleQuillChange = (value) => {
        if (formData.description !== value) {
            // Only update if the value changes
            validateField('description', value);
            setFormData({ ...formData, description: value });
        }
    };

    const validateField = (name, value) => {
        let errorMessage = '';

        // Allow emojis and punctuation, disallow angle brackets, min length 4
        const nameRegex = /^[^<>]{4,}$/;

        const priceRegex = /^(100(\.00?)?|(\d{1,2}(\.\d{1,2})?))$/;
        const trayPriceRegex = /^(\d+)(?:\.(\d{1,2}))?$/;

        switch (name) {
        case 'name':
            if (!value) {
                errorMessage = 'Food name is required.';
            } else if (!nameRegex.test(value)) {
                errorMessage = 'Food name should be at least 4 characters.';
            }
            break;
        case 'price':
            if (!value) {
                errorMessage = 'Price is required.';
            } else if (!priceRegex.test(value)) {
                errorMessage = 'Price must be a valid number.';
            }
            break;
        case 'menuType':
            if (!value) {
                errorMessage = 'Menu Type is required.';
            }
            break;
        case 'description':
            if (!value) {
                errorMessage = 'Description is required.';
            } else if (value.length < 10) {
                errorMessage = 'Description should be at least 10 characters.';
            }
            break;
        case 'Ingredients':
            if (!value) {
                errorMessage = 'Ingredients are required.';
            } else if (value.length < 10) {
                errorMessage = 'Ingredients should be at least 10 characters.';
            }
            break;
        case 'vegetarian':
            if (value === undefined || value === null) {
                errorMessage = 'Food Type is required.';
            }
            break;
        case 'Small_tray':
        case 'Medium_tray':
        case 'Large_tray':
            if (value && !trayPriceRegex.test(String(value).trim())) {
                errorMessage = 'Enter a valid amount (e.g., 49.99).';
            }
            break;
        default:
            break;
        }

        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate all fields against their specific rules
        let isValid = true;
        const fieldsToValidate = [
            'name',
            'price',
            'menuType',
            'description',
            'Ingredients',
            'vegetarian',
        ];

        fieldsToValidate.forEach((key) => {
            validateField(key, formData[key]); // Re-validate each field
            if (formErrors[key]) {
                isValid = false; // If any field has an error, set isValid to false
            }
        });

        // Additional party tray checks when Party is enabled
        if (formData.Party) {
            const s = String(formData.Small_tray || '').trim();
            const m = String(formData.Medium_tray || '').trim();
            const l = String(formData.Large_tray || '').trim();
            const anyProvided = Boolean(s || m || l);
            const trayRgx = /^(\d+)(?:\.(\d{1,2}))?$/;

            // clear previous errors
            setFormErrors((prev) => ({ ...prev, partyTray: '', Small_tray: '', Medium_tray: '', Large_tray: '' }));

            if (!anyProvided) {
                isValid = false;
                setFormErrors((prev) => ({ ...prev, partyTray: 'Enter at least one tray price or turn off Party.' }));
            }
            if (s && !trayRgx.test(s)) {
                isValid = false;
                setFormErrors((prev) => ({ ...prev, Small_tray: 'Enter a valid amount (e.g., 49.99).' }));
            }
            if (m && !trayRgx.test(m)) {
                isValid = false;
                setFormErrors((prev) => ({ ...prev, Medium_tray: 'Enter a valid amount (e.g., 79.99).' }));
            }
            if (l && !trayRgx.test(l)) {
                isValid = false;
                setFormErrors((prev) => ({ ...prev, Large_tray: 'Enter a valid amount (e.g., 109.99).' }));
            }
        }

        if (isValid) {
            handleSave({ ...formData });
        } else {
            toast.error('Please fix the errors before submitting.');
        }
    };

    if (loading) {
        return (
            <div>
                <Loader />
            </div>
        );
    }

    return (
        <div className="update-menu-items-main-container">
            <div
                className="back-btn-menuItems"
                type="button"
                onClick={handleBack}
            >
                <div className="back-arrow-image-vendor">
                    <img src={LeftArrow} alt="" />
                </div>
            </div>
            <div className="menu-new-div">
                <div className="menu-image-container">
                    <div className="edit-image-or-video-svg-and-btn">
                        <VendorImageMenuPlaceholderSvg
                            onClick={() => fileInputRef.current.click()}
                        />
                        <h5 className="menu-add-item-update-photo-heading">
              Click to add Photo
                        </h5>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            accept="image/*,video/*"
                            onChange={handleFileChange}
                        />
                    </div>

                    <div className="image-or-video-preview-menuitems">
                        {previewFile && fileType === 'image' && (
                            <img
                                src={previewFile}
                                alt="Selected Preview"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            />
                        )}
                        {previewFile && fileType === 'video' && (
                            <video width="100%" height="100%" controls>
                                <source src={previewFile} type="video/mp4" />
                Your browser does not support the video tag.
                            </video>
                        )}
                    </div>
                </div>

                <div className="menu-additem-rightside-content">
                    <div className="menu-additem-rightside-content-1">
                        <div className="menu-additem-food-name-container">
                            <div className="add-menu-name-input">
                                <p className="menu-additem-food-name-text">Food Name</p>

                                <input
                                    type="text"
                                    placeholder="Enter Food Name"
                                    className="menu-additem-food-name-inputbox"
                                    name="name"
                                    value={formData?.name}
                                    onChange={handleChange}
                                    maxLength={30}
                                />
                            </div>
                            {formErrors?.name && (
                                <div className="error-message">{formErrors?.name}</div>
                            )}
                        </div>

                        <div className="menu-additem-food-name-container">
                            <div className="add-menu-name-input">
                                <p className="menu-additem-food-name-text">Menu Type</p>
                                <select
                                    className="menu-additem-menu-type-inputbox"
                                    name="menuType"
                                    value={formData?.menuType}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Menu</option>
                                    {menuTypes.map((menu) => (
                                        <option key={menu?.ID} value={menu?.ID}>
                                            {menu?.Menu_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {formErrors?.menuType && (
                                <div className="error-message">{formErrors?.menuType}</div>
                            )}
                        </div>
                    </div>

                    <div className="menu-additem-rightside-content-1">
                        <div className="menu-additem-food-name-container">
                            <div className="add-menu-name-input">
                                <p className="menu-additem-food-name-text">Price</p>
                                <input
                                    type="text"
                                    placeholder="$"
                                    className="menu-additem-food-name-inputbox"
                                    name="price"
                                    value={formData?.price}
                                    onChange={handleChange}
                                />
                            </div>
                            {formErrors?.price && (
                                <div className="error-message">{formErrors?.price}</div>
                            )}
                        </div>
                        <div className="menu-additem-food-name-container">
                            <div className="add-menu-name-input">
                                <p className="menu-additem-food-name-text">Food Type</p>
                                <select
                                    className="menu-additem-menu-type-inputbox"
                                    name="vegetarian"
                                    value={formData?.vegetarian}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Type</option>
                                    <option value="false">Non-Veg</option>
                                    <option value="true">Veg</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Available For: Daily and Party */}
                    <div className="menu-additem-rightside-content-1" style={{ marginTop: 10 }}>
                        <div className="menu-additem-food-name-container full-row" style={{ width: '100%' }}>
                            <div className="add-menu-name-input" style={{ width: '100%' }}>
                                <p className="menu-additem-food-name-text">Available For</p>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 12, color: '#2c3142' }}>Daily</span>
                                        <div
                                            className={`menu-toggle-switch ${formData.Daily ? 'on' : 'off'}`}
                                            onClick={() => setFormData(prev => ({ ...prev, Daily: !prev.Daily }))}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="menu-toggle-switch-inner">
                                                <div className="menu-toggle-switch-circle" style={{ right: formData.Daily ? 3 : 'auto', left: formData.Daily ? 'auto' : 3 }}></div>
                                            </div>
                                            <span className={`menu-toggle-state-text ${formData.Daily ? 'on' : 'off'}`}>{formData.Daily ? 'on' : 'off'}</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 12, color: '#2c3142' }}>Party</span>
                                        <div
                                            className={`menu-toggle-switch ${formData.Party ? 'on' : 'off'}`}
                                            onClick={() => setFormData(prev => ({
                                                ...prev,
                                                Party: !prev.Party,
                                                // Clear tray prices when turning off Party
                                                Small_tray: !prev.Party ? prev.Small_tray : '',
                                                Medium_tray: !prev.Party ? prev.Medium_tray : '',
                                                Large_tray: !prev.Party ? prev.Large_tray : '',
                                            }))}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="menu-toggle-switch-inner">
                                                <div className="menu-toggle-switch-circle" style={{ right: formData.Party ? 3 : 'auto', left: formData.Party ? 'auto' : 3 }}></div>
                                            </div>
                                            <span className={`menu-toggle-state-text ${formData.Party ? 'on' : 'off'}`}>{formData.Party ? 'on' : 'off'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {formData.Party && (
                        <div className="menu-additem-rightside-content-1" style={{ marginTop: 12 }}>
                            <div className="menu-additem-food-name-container full-row" style={{ width: '100%' }}>
                                <div className="add-menu-name-input" style={{ width: '100%' }}>
                                    <p className="menu-additem-food-name-text">Party Tray Prices</p>
                                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                        <div style={{ minWidth: 180 }}>
                                            <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Small Tray</label>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                placeholder="$ e.g., 49.99"
                                                className="menu-additem-food-name-inputbox"
                                                name="Small_tray"
                                                value={formData.Small_tray}
                                                onChange={(e) => handleChange({ target: { name: 'Small_tray', value: e.target.value } })}
                                            />
                                            {formErrors.Small_tray && (
                                                <div className="error-message" style={{ marginTop: 4 }}>{formErrors.Small_tray}</div>
                                            )}
                                        </div>
                                        <div style={{ minWidth: 180 }}>
                                            <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Medium Tray</label>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                placeholder="$ e.g., 79.99"
                                                className="menu-additem-food-name-inputbox"
                                                name="Medium_tray"
                                                value={formData.Medium_tray}
                                                onChange={(e) => handleChange({ target: { name: 'Medium_tray', value: e.target.value } })}
                                            />
                                            {formErrors.Medium_tray && (
                                                <div className="error-message" style={{ marginTop: 4 }}>{formErrors.Medium_tray}</div>
                                            )}
                                        </div>
                                        <div style={{ minWidth: 180 }}>
                                            <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Large Tray</label>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                placeholder="$ e.g., 109.99"
                                                className="menu-additem-food-name-inputbox"
                                                name="Large_tray"
                                                value={formData.Large_tray}
                                                onChange={(e) => handleChange({ target: { name: 'Large_tray', value: e.target.value } })}
                                            />
                                            {formErrors.Large_tray && (
                                                <div className="error-message" style={{ marginTop: 4 }}>{formErrors.Large_tray}</div>
                                            )}
                                        </div>
                                    </div>
                                    {formErrors.partyTray ? (
                                        <div className="error-message" style={{ marginTop: 6 }}>{formErrors.partyTray}</div>
                                    ) : (
                                        <p style={{ marginTop: 6, fontSize: 11, color: '#6b7280' }}>Leave a tray price blank if you do not offer that size.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="react-quill-description-ingrediants">
                        <div className="add-menu-name-input">
                            <p className="menu-additem-food-name-text">Description</p>
                            <ReactQuill
                                theme="snow"
                                name="description"
                                value={formData?.description || ''}
                                onChange={handleQuillChange}
                                placeholder="Enter Description"
                            />
                        </div>
                        {formErrors?.description && (
                            <div className="error-message">{formErrors?.description}</div>
                        )}
                    </div>

                    <div className="react-quill-description-ingrediants">
                        <div className="add-menu-name-input">
                            <p className="menu-additem-food-name-ingridents">Ingredients</p>
                            <ReactQuill
                                theme="snow"
                                value={formData?.Ingredients || ''}
                                onChange={handleIngredientsChange}
                                placeholder="Enter Ingridents"
                            />
                        </div>
                        {formErrors?.Ingredients && (
                            <div className="error-message">{formErrors?.Ingredients}</div>
                        )}
                    </div>

                    <button
                        className="menu-additem-btn"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Updating...' : 'Update Item'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UpdateItem;
